// Mega menu navigation structure shared between desktop dropdown and mobile accordion.
export const megaMenuCategories = [
  {
    name: 'Machine Guards',
    path: '#',
    subcategories: [
      {
        name: 'Conveyor Guards',
        path: '/products?category=Conveyor Guards',
        products: [
          { name: 'Conveyor Side Guards', path: '/products/machine-guards/conveyor-guards/conveyor-side-guards/' },
          { name: 'Pulley Guards', path: '/products/machine-guards/conveyor-guards/pulley-guards/' },
          { name: 'Return Idler Guards', path: '/products/machine-guards/conveyor-guards/return-idler-guards/' },
          { name: 'Conveyor Canopy', path: '/products/machine-guards/conveyor-guards/conveyor-canopy/' }
        ]
      },
      {
        name: 'Rotating Equipment Guards',
        path: '/products?category=Rotating Equipment Guards',
        products: [
          { name: 'Belt / Chain / Gear Drive Guards', path: '/products/belt-chain-gear-drive-guards' },
          { name: 'Compressor / Pump Guards', path: '/products/compressor-pump-guards' },
          { name: 'Coupling Guards', path: '/products/coupling-guards' },
          { name: 'Flange Bearing Guards', path: '/products/flange-bearing-guards' },
          { name: 'Pump Gland Guards', path: '/products/pump-gland-guards' }
        ]
      },
      {
        name: 'Perimeter Barrier Guards',
        path: '/products?category=Perimeter Barrier Guards',
        products: [
          { name: 'Workstation Barrier Guards', path: '/products/workstation-barrier-guards' },
          { name: 'Safety Fencing', path: '/products/safety-fencing' },
          { name: 'Modular Handrails', path: '/products/modular-handrails' }
        ]
      },
      {
        name: 'Workshop Equipment Guards',
        path: '/products?category=Workshop Machine Guards',
        products: [
          { name: 'Lathe Machine Guards', path: '/products/lathe-machine-guards' },
          { name: 'Drill Machine Guards', path: '/products/drill-machine-guards' },
          { name: 'Milling Machine Guards', path: '/products/milling-machine-guards' }
        ]
      },
      {
        name: 'Smart Guards (with Interlocks)',
        path: '/products/smart-guards-with-interlocks',
        products: []
      },
      {
        name: 'Modular Rain Guards',
        path: '/products?category=Modular Rain Guards',
        products: [
          { name: 'Foot Mounted Motor Guards', path: '/products/foot-mounted-motor-guards' },
          { name: 'Flange Mounted Motor Guards', path: '/products/flange-mounted-motor-guards' }
        ]
      }
    ]
  },
  {
    name: 'Dust Suppression System',
    path: '/products?category=Dust Suppression System',
    subcategories: [
      { name: 'Wind Fence', path: '/products/wind-fence', products: [] },
      { name: 'Dry Fog', path: '/products/dry-fog', products: [] },
      { name: 'High Pressure Mist', path: '/products/high-pressure-mist', products: [] }
    ]
  },
  {
    name: 'Wear Resistance',
    path: '/products?category=Wear Resistance',
    subcategories: [
      { name: 'Ceramic Tiles High Aluminium (Liners)', path: '/products/ceramic-tiles-high-aluminium-liners', products: [] },
      { name: 'Ceramic Pulley Lagging', path: '/products/ceramic-pulley-lagging', products: [] },
      { name: 'Ceramic Pad Lagging', path: '/products/ceramic-pad-lagging', products: [] }
    ]
  }
];

export const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Products', path: '/products', hasDropdown: true },
  { name: 'Clients', path: '/clients' },
  { name: 'Contact', path: '/contact' }
];
